import React, { useState } from "react";
import styled from "styled-components";
import { LIST_YEAR } from "./../config";

const Listyear = ({ getYearCallback }) => {
    const [listYear, setListYear] = useState(LIST_YEAR);

    const handleYear = (year, e) => {
        e.preventDefault();
        let newListYear = listYear;
        newListYear.map(function (x) {
            x.is_active = false;
            return x;
        });
        const objIndex = newListYear.findIndex((obj) => obj.value === year);
        newListYear[objIndex].is_active = true;
        getYearCallback(year);
        setListYear([...newListYear]);
    };

    return (
        <Container>
            {listYear.map((year) => (
                <div
                    className={
                        year.is_active ? "year-item active" : "year-item"
                    }
                    key={year.value}
                >
                    <a href="/#" onClick={(e) => handleYear(year.value, e)}>
                        {year.title}
                    </a>
                </div>
            ))}
        </Container>
    );
};
const Container = styled.div`
    display: flex;
    .year-item {
        border-left: 1px solid #f26c26;
        width: 100px;
        text-align: center;
        font-size: 2.2rem;
        &.active {
            background-color: red;
            a {
                color: white;
            }
        }
        a {
            cursor: pointer;
        }
    }
    div:last-child {
        border-right: 1px solid #f26c26;
    }
    @media only screen and (max-width: 767px) {
        overflow-x: scroll;
        .year-item {
            font-size: 1.2rem;
        }
    }
`;

export default Listyear;
